:host {
  @include reset-host;
}

:host .failsurance-card {
  position: relative;

  display: flex;
  overflow: clip;

  background: $color-teal;
  border-radius: rem(16);

  @include mq('max', 'sm') {
    flex-direction: column;
  }
}

:host .decoration-icon img {
  position: absolute;
  top: 3%;
  left: 50%;

  display: block;

  width: rem(320);

  transform: translateX(-50%) rotate(-15deg);
  opacity: 0.1;

  @include mq('max', 'md') {
    display: none;
  }
}

:host .text-wrapper {
  width: 55%;
}

:host .image-wrapper {
  width: 45%;
}

:host .text-wrapper,
:host .image-wrapper {
  @include mq('max', 'sm') {
    width: unset;
  }
}

:host .text-wrapper {
  --title-color: #{$white};
  --paragraph-color: #{$white};

  display: flex;
  flex-direction: column;
  align-items: flex-start;

  padding: rem(78);
  padding-right: 0;
  padding-bottom: rem(16);

  @include mq('max', 'sm') {
    align-items: center;
    padding: rem(28);

    text-align: center;
  }
}

:host .title-accent {
  display: block;

  font-size: 1.8em;
  font-family: $ff-title;
  font-style: normal;
}

:host .learner-sign {
  height: rem(74);

  transform: rotate(-9.3deg) translateY(20%) translateX(-5%);

  @include mq('max', 'sm') {
    height: rem(60);
  }
}

:host .legal-mention {
  margin-top: rem(24);
}

:host .image-wrapper {
  position: relative;

  @include mq('max', 'sm') {
    height: rem(425);
  }

  .img {
    @include cover;
    object-position: left center;

    @include mq('max', 'sm') {
      object-position: top center;
    }
  }
}
